import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
import React, { useRef, useEffect, useState } from 'react'
import RightMenu from "@/components/RightMenu";
import {getImagePathWithTheme, getIntValue} from "@/utils";
import global from "@/global";
import {APP_WEB} from "@/electron_interactive";


export default props => {
    const {node} = props;
    let tableWrapperRef = useRef<any>(null);
    const [count, setCount] = useState(false);

    let mEditor = props.editor;

    /**
     * 不要乱计算了。用默认的就行了。
     */
    const resetTableWidth = ()=>{
        // if (node.attrs.tableFixWidth && node.attrs.tableFixWidth !== '0px') {
        //     let nFixWidth = getIntValue(node.attrs.tableFixWidth.replace('px',''),700);
        //     tableWrapperRef.current.querySelector('table').style.width = (nFixWidth - 0)+'px';//给右边留点空间.
        // }
    }

    useEffect(() => {
            let tableFocus = false
            const tableWrapperElement = tableWrapperRef.current;
            var currentTableDom = tableWrapperElement.getElementsByTagName('table')[0];
            var currentTableRec = currentTableDom.getBoundingClientRect();


            // 更新最后一行添加和最后一列添加的位置
            let rowControlDom = tableWrapperElement.getElementsByClassName('rowControl')[0]
            let colControlDom = tableWrapperElement.getElementsByClassName('colControl')[0]


            let tableControlDom = tableWrapperElement.getElementsByClassName('tableControl')[0]
            const tableFocusListener = setInterval(() => {
                let newTableFocus = tableWrapperElement.getElementsByTagName('table')[0].getElementsByClassName('has-focus').length === 0 ? false : true
                if (newTableFocus != tableFocus) {
                    tableFocus = newTableFocus;
                    if (tableFocus) {
                        tableControlDom.style.opacity = '1';
                    } else {
                        tableControlDom.style.opacity = '0';
                    }
                }
            }, 300)

        // let divTBody = tableWrapperElement.getElementsByTagName("div")[0];
        //     if (divTBody){
        //         divTBody.style.display = 'table-row-group';
        //         divTBody.style.verticalAlign = 'middle';
        //
        //         // const tbody = document.createElement('tbody');
        //         // tbody.innerHTML = divTBody.innerHTML;
        //         // // currentTableDom.appendChild(tbody);
        //         //
        //         // divTBody.remove();
        //     }


            let rowIndex
            let cellIndex

            //  根据当前所在的行
            let tablelist = mEditor.$doc.querySelectorAll('table')
            let nowTableIndex
            setTimeout(() => {
                // 获取当前表格的data-id
                let nowFirstRowId = currentTableDom.getElementsByTagName('tr')[0].getAttribute('data-id')
                // 获取当前所在的表格序号
                for (let i = 0; i < tablelist.length; i++) {
                    if (tablelist[i].children[0].attributes.id === nowFirstRowId) {
                        nowTableIndex = i
                        break;
                    }
                }


                // 初始化时对col数量宽度进行绑定
                for (let i = 0; i < tableWrapperElement.getElementsByTagName('tr')[0].cells.length; i++) {
                    let colgroup = tableWrapperElement.getElementsByTagName('table')[0].getElementsByTagName('colgroup')[0];
                    const newCol = document.createElement('col');
                    const nowColWidth = tableWrapperElement.getElementsByTagName('tr')[0].cells[i].getAttribute('colwidth')
                    if (nowColWidth) {
                        newCol.style.width = `${nowColWidth}px`;
                    }
                    colgroup.appendChild(newCol);
                }
            }, 80)

            tableControlDom.style.left = `${currentTableRec.width - 36}px`

            // 判断是不是非粘贴表格，不然重新赋值
            let idCount = 0
            mEditor.$doc.querySelectorAll('table').forEach(table => {
                if (table.node.attrs.id === node.attrs.id) {
                    idCount += 1
                }
            });
            if (idCount === 2) {
                node.attrs.id = crypto.randomUUID();
                node.attrs.tableFixWidth = null;
            }

            resetTableWidth();

            let addLastRow = tableWrapperElement.getElementsByClassName("tableIcon-add-bottom-outer")[0]
            let addLastCol = tableWrapperElement.getElementsByClassName("tableIcon-add-right-outer")[0]
            if (node.attrs.from != 'EditorCardItem'){
                const resizeObserver = new ResizeObserver(entries => {
                    for (let entry of entries) {
                        // 实时同步table的宽度和高度
                        addLastRow.style.width = `${entry.contentRect.width}px`;
                        addLastCol.style.left = `${entry.contentRect.width}px`
                        tableControlDom.style.left = `${entry.contentRect.width - 28}px`
                        node.attrs.tableFixWidth = `${entry.contentRect.width}px`

                        const {state, dispatch} = mEditor.view;  // 获取编辑器的 state 和 dispatch
                        try{
                            const tr = state.tr.setNodeMarkup(
                                props.getPos(),  // 获取当前节点的位置
                                null,      // 不修改节点类型
                                {...node.attrs, tableFixWidth: `${entry.contentRect.width}px`}  // 更新 attrs 中的 tableFixWidth
                            );
                            dispatch(tr);  // 派发 transaction，触发更新
                        }catch (e){

                        }
                    }
                });
                resizeObserver.observe(tableWrapperElement.getElementsByTagName('table')[0]);
            }


            const calculateTableDimensions = (table) => {
                let tableWidth = 0
                const firstRowCells = table.rows[0].cells; // 获取第一行的单元格const firstColumnCells = Array.from(table.rows).map(row => row.cells[0]); // 获取第一列的单元格// 计算表格宽度：第一行所有单元格的宽度之和let tableWidth = 0;
                for (let cell of firstRowCells) {
                    tableWidth += cell.offsetWidth;
                }
                return {
                    width: tableWidth,
                };
            }
            const mouseover = (event) => {
                const target = event.target;
                if (target.tagName.toLowerCase() === 'td' || target.tagName.toLowerCase() === 'th') {
                    const currentTable = target.parentNode.parentNode.parentNode
                    const currentTableRect = currentTable.getBoundingClientRect()
                    const rowCount = currentTable.rows.length;
                    const colCount = currentTable.getElementsByTagName('tr')[0].cells.length;

                    cellIndex = target.cellIndex;
                    rowIndex = target.parentNode.rowIndex;
                    const lastCell = cellIndex === colCount - 1 ? true : false
                    const lastRow = rowIndex === rowCount - 1 ? true : false


                    if (lastRow) {
                        addLastRow.style.opacity = '1'
                    } else {
                        addLastRow.style.opacity = '0'
                    }

                    if (lastCell) {
                        addLastCol.style.opacity = '1'
                    } else {
                        addLastCol.style.opacity = '0'
                    }

                    // 显示相应的行/列 标志
                    if (rowIndex != -1 && rowIndex < currentTable.rows.length){
                        const nowCellDom = currentTable.rows[rowIndex].cells[cellIndex]
                        const nowCellRec = nowCellDom.getBoundingClientRect();
                        rowControlDom.style.opacity = '1'
                        colControlDom.style.opacity = '1'
                        rowControlDom.style.top = `${nowCellRec.top + nowCellRec.height / 2 - currentTableRect.top - 14.5}px`
                        colControlDom.style.left = `${nowCellRec.left + nowCellRec.width / 2 - currentTableRect.left - 14.5}px`
                    }

                } else if (target.tagName.toLowerCase() === 'p' && (target.parentNode.tagName.toLowerCase() === 'td' || target.parentNode.tagName.toLowerCase() === 'th')) {
                    const currentTable = target.parentNode.parentNode.parentNode.parentNode
                    const currentTableRect = currentTable.getBoundingClientRect()
                    const rowCount = currentTable.rows.length;
                    const colCount = currentTable.getElementsByTagName('tr')[0].cells.length;

                    cellIndex = target.parentNode.cellIndex;
                    rowIndex = target.parentNode.parentNode.rowIndex;
                    const lastCell = cellIndex === colCount - 1 ? true : false
                    const lastRow = rowIndex === rowCount - 1 ? true : false

                    if (lastRow) {
                        addLastRow.style.opacity = '1'
                    } else {
                        addLastRow.style.opacity = '0'
                    }

                    if (lastCell) {
                        addLastCol.style.opacity = '1'
                    } else {
                        addLastCol.style.opacity = '0'
                    }

                    // 显示相应的行/列 标志
                    if (rowIndex != -1 && rowIndex < currentTable.rows.length) {
                        const nowCellDom = currentTable.rows[rowIndex].cells[cellIndex]
                        const nowCellRec = nowCellDom.getBoundingClientRect();
                        rowControlDom.style.opacity = '1'
                        colControlDom.style.opacity = '1'
                        rowControlDom.style.top = `${nowCellRec.top + nowCellRec.height / 2 - currentTableRect.top - 14.5}px`
                        colControlDom.style.left = `${nowCellRec.left + nowCellRec.width / 2 - currentTableRect.left - 14.5}px`
                    }
                } else if (target.className === 'tableIcon-add-bottom-outer' || target.className === 'tableIcon-add-bottom') {
                    addLastRow.style.opacity = '1'
                } else if (target.className === 'tableIcon-add-right-outer' || target.className === 'tableIcon-add-right') {
                    addLastCol.style.opacity = '1'
                }
            };
            const mouseleave = (event) => {
                addLastRow.style.opacity = '0'
                addLastCol.style.opacity = '0'
                rowControlDom.style.opacity = '0'
                colControlDom.style.opacity = '0'
                // tableControlDom.style.opacity='0';
            }
            const addLastRowByClick = (event) => {
                if (addLastRow.style.opacity == '1') {
                    const table = tableWrapperElement.getElementsByTagName("table")[0];
                    let lstRowNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[table.rows.length - 1]
                    mEditor.chain().focus().selectRow(lstRowNP.pos).run();
                    mEditor.chain().focus().addRowAfter().run()
                }
            }
            const addLastColByClick = (event) => {
                if (addLastCol.style.opacity == '1') {
                    const table = tableWrapperElement.getElementsByTagName("table")[0];
                    let lastColNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[0].querySelectorAll('tableCell')[table.getElementsByTagName('tr')[0].cells.length - 1]
                    if (!lastColNP) {
                        lastColNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[0].querySelectorAll('tableHeader')[table.rows[0].cells.length - 1]
                    }
                    mEditor.chain().focus().selectColumn(lastColNP.pos - 1).run();
                    if (mEditor.chain().focus().addColumnAfter().run()) {
                        // 先把table的width取消掉
                        tableWrapperElement.getElementsByTagName('table')[0].style.removeProperty('width');
                        let colgroup = tableWrapperElement.getElementsByTagName('table')[0].getElementsByTagName('colgroup')[0];
                        const newCol = document.createElement('col');
                        colgroup.appendChild(newCol);
                    }
                }
            }
            const rowControlByClick = async (event) => {
                // event.stopPropagation()
                // event.preventDefault()
                let currentTableNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex]

                const menus = [
                    {
                        label: 'Insert above',
                        key: 'Insert above',
                        enabled: (rowIndex === 0 && currentTableNP.attributes?.toggleHeaderRow) ? false : true
                    },
                    {
                        label: 'Insert below',
                        key: 'Insert below',
                    },
                    {
                        label: 'Delete',
                        key: 'Delete'
                    }
                ]
                let nowRowNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[rowIndex]
                mEditor.chain().focus().selectRow(nowRowNP.pos).run();
                const key = await RightMenu.open(event.pageX, event.pageY, menus,mEditor)


                if (key === 'Insert above') {
                    mEditor.chain().focus().addRowBefore().run();
                }
                if (key === 'Insert below') {
                    mEditor.chain().focus().addRowAfter().run();
                }
                if (key === 'Delete') {
                    mEditor.chain().focus().deleteRow().run();
                }
            }
            const colControlByClick = async (event) => {
                // event.stopPropagation()
                // event.preventDefault()
                let currentTableNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex]
                const menus = [
                    {
                        label: 'Insert left',
                        key: 'Insert left',
                        enabled: (cellIndex === 0 && currentTableNP.attributes?.toggleHeaderCell) ? false : true
                    },
                    {
                        label: 'Insert right',
                        key: 'Insert right',
                    },
                    {
                        label: 'Delete',
                        key: 'Delete'
                    }
                ]
                let nowColNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[0].querySelectorAll('tableCell')[cellIndex]
                if (!nowColNP) {
                    nowColNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[0].querySelectorAll('tableHeader')[cellIndex]
                }
                mEditor.chain().focus().selectColumn(nowColNP.pos - 1).run();
                const key = await RightMenu.open(event.pageX, event.pageY, menus,mEditor)

                if (key === 'Insert left') {
                    if (mEditor.chain().focus().addColumnBefore().run()) {
                        // 先把table的width取消掉
                        tableWrapperElement.getElementsByTagName('table')[0].style.removeProperty('width');
                        let colgroup = tableWrapperElement.getElementsByTagName('table')[0].getElementsByTagName('colgroup')[0];
                        let cols = colgroup.getElementsByTagName('col');
                        const newCol = document.createElement('col');
                        colgroup.insertBefore(newCol, cols[cellIndex]);
                    }
                }
                if (key === 'Insert right') {
                    if (mEditor.chain().focus().addColumnAfter().run()) {
                        // 先把table的width取消掉
                        tableWrapperElement.getElementsByTagName('table')[0].style.removeProperty('width');
                        let colgroup = tableWrapperElement.getElementsByTagName('table')[0].getElementsByTagName('colgroup')[0];
                        let cols = colgroup.getElementsByTagName('col');
                        const newCol = document.createElement('col');
                        colgroup.appendChild(newCol);
                        if (cellIndex >= 0 && cellIndex < cols.length - 1) {
                            colgroup.insertBefore(newCol, cols[cellIndex + 1]);
                        } else {
                            colgroup.appendChild(newCol);
                        }
                    }
                }
                if (key === 'Delete') {
                    mEditor.chain().focus().deleteColumn().run();
                    let colgroup = tableWrapperElement.getElementsByTagName('table')[0].getElementsByTagName('colgroup')[0];
                    let cols = colgroup.getElementsByTagName('col');
                    colgroup.removeChild(cols[cellIndex])
                }
            }

            const tableCellfocus = async (event) => {
                tableControlDom.style.opacity = '1';
            }

            const tableControlClick = async (event) => {
                // 判断当前的表格头状态
                let currentTableNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex]
                const menus = [
                    {
                        label: 'Header row',
                        key: 'Header row',
                        type: 'toggleBtn',
                        toggleStatus: currentTableNP.attributes?.toggleHeaderRow ? true : false,
                        nowTableIndex: nowTableIndex
                    },
                    {
                        label: 'Header column',
                        key: 'Header column',
                        type: 'toggleBtn',
                        toggleStatus: currentTableNP.attributes?.toggleHeaderCell ? true : false,
                        nowTableIndex: nowTableIndex
                    },
                    {
                        label: 'Delete',
                        key: 'Delete'
                    }
                ]
                const key = await RightMenu.open(event.pageX, event.pageY, menus,mEditor)
                if (key === 'Delete') {
                    // 聚焦到第一行
                    let nowRowNP = mEditor.$doc.querySelectorAll('table')[nowTableIndex].querySelectorAll('tableRow')[0]
                    mEditor.chain().focus().selectRow(nowRowNP.pos).run();
                    mEditor.chain().focus().deleteTable().run();
                }
            }

            if (node.attrs.from != 'EditorCardItem'){
                if (tableWrapperElement) {
                    tableWrapperElement.addEventListener('mouseover', mouseover);
                    tableWrapperElement.addEventListener('mouseleave', mouseleave);
                }
                addLastRow.addEventListener('click', addLastRowByClick)
                addLastCol.addEventListener('click', addLastColByClick)
                rowControlDom.addEventListener('click', rowControlByClick)
                colControlDom.addEventListener('click', colControlByClick)
                tableControlDom.addEventListener('click', tableControlClick)
            }

            const handleTableIfHidden = (event: any) => {
                if (event.detail.id === node.attrs.id) {
                    node.attrs.ifhidden = event.detail.ifhidden;
                }
            }
            document.addEventListener('table-ifHidden', handleTableIfHidden)


            // 清理函数，在组件卸载时移除事件监听器
            return () => {
                if (tableWrapperElement) {
                    tableWrapperElement.removeEventListener('mouseover', mouseover);
                    tableWrapperElement.removeEventListener('mouseleave', mouseleave);
                }
                if (addLastRow) {
                    addLastRow.removeEventListener('click', addLastRowByClick)
                }
                if (addLastCol) {
                    addLastCol.removeEventListener('click', addLastColByClick)
                }
                if (rowControlDom) {
                    rowControlDom.removeEventListener('click', rowControlByClick)
                }
                if (colControlDom) {
                    colControlDom.removeEventListener('click', colControlByClick)
                }
                if (tableControlDom) {
                    tableControlDom.removeEventListener('click', tableControlClick)
                }
                clearInterval(tableFocusListener)
            };
        },
        []);
    return (
        <NodeViewWrapper ifhidden={node.attrs.ifhidden} id="tableWrapper" style={{ display: node.attrs.ifhidden ? 'none' : 'block' }}>
            <div className="tableWrapper" ref={tableWrapperRef} style={{paddingRight: '16px', overflow: 'visible'}}>
                <NodeViewContent as='table'>
                    <colgroup>

                    </colgroup>
                </NodeViewContent>

                <div className="rowControl" style={{display:(global.g_isPresentMode || APP_WEB)?'none':''}}>
                    <img style={{width: '18px', height: '22px'}} src={getImagePathWithTheme('table_row_more')}/>
                </div>
                <div className="colControl"  style={{display:(global.g_isPresentMode || APP_WEB)?'none':''}}>
                    <img style={{width: '22px', height: '18px'}} src={getImagePathWithTheme('table_col_more')}/>
                </div>
                <div className="tableControl" style={{display:(global.g_isPresentMode || APP_WEB)?'none':''}}>
                    <img style={{width: '22px', height: '18px'}} src={getImagePathWithTheme('table_more')}/>
                </div>
                <div className="tableIcon-add-right-outer" style={{flexShrink: '0',display:(global.g_isPresentMode || APP_WEB)?'none':''}}>
                    <div className="tableIcon-add-right">
                        <img src="atom://note-add-Icon.jpeg" width="10" height="10"/>
                    </div>
                </div>
                <div className="tableIcon-add-bottom-outer" style={{display:(global.g_isPresentMode || APP_WEB)?'none':''}}>
                    <div className="tableIcon-add-bottom">
                        <img src="atom://note-add-Icon.jpeg" width="10" height="10"/>
                    </div>
                </div>
            </div>
        </NodeViewWrapper>
    )
}
















